// Typeguard Function
export var isClipboardEvent = function isClipboardEvent(event) {
  return 'clipboardData' in event;
};